import { Button, Typography } from '@arionbanki/arionui';
import { FinishAV } from './FinishAV';
import { FinishPrimary } from './FinishPrimary';
import { FinishSecondary } from './FinishSecondary';
import { useFinish } from './useFinish';
import topImg from 'img/finish-top.svg';
import topImgSecondary from 'img/gold3.jpg';

export function Finish() {
	const props = useFinish();
	const { keys, t } = props;
	return (
		<div className="finish-page">
			<div className="stripe stripe-secondary">
				<div className="stripe-fix">
					<div className="container">
						<div className="row">
							<div className="col-12 col-lg-6">
								<Typography TagName="h1" className="mt-5">
									<span className="text-white">{t(keys.title, 'finish', true)}</span>
								</Typography>
								<Typography TagName="p" className="mt-4 mb-5">
									<span className="text-white">{t(keys.description, 'finish', true)}</span>
								</Typography>
								<Button className="w-75" onClick={props.buttonAction} size="large">
									{t(keys.btn, 'finish', true)}
								</Button>
							</div>
							<div className="col-6 d-none d-lg-block">
								<img alt="" className="primary" src={topImg} />
								<img alt="" className="secondary" src={topImgSecondary} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="container">
				<div className="row">
					<div className="col-12 mb-5">
						{props.showTitle && <Typography TagName="h3">{t(keys.header, 'finish')}</Typography>}
					</div>
				</div>
				<div className="row">
					<FinishAV {...props} />
					<FinishPrimary {...props} />
					<FinishSecondary {...props} />
				</div>
			</div>
		</div>
	);
}
